
export class response {
    amount: string;
    currency: string;
    reference_number: string;
    status: string;
    authorization_code: string;
    date: date;
    error_code: string;
    error_description: string;
}

export class date {
    date: string;
    timezone_type: number;
    timezone: string;
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/booking/response.ts